import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ChartModule } from 'angular2-chartjs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxEchartsModule } from 'ngx-echarts';
import * as echarts from 'echarts';
import { HttpClientModule } from '@angular/common/http';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import {NgxPaginationModule} from 'ngx-pagination';
import {NgxPrintModule} from 'ngx-print';
import { NgxMaskModule, IConfig } from 'ngx-mask'
import { NgxGalleryModule } from 'ngx-gallery-9';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SidemenuComponent } from './pages/ui/sidemenu/sidemenu.component';
import { HeaderComponent } from './pages/ui/header/header.component';
import { FooterComponent } from './pages/ui/footer/footer.component';
import { DashboardComponent } from './pages/dashboard/dashboard/dashboard.component';
import { FinancialPositionComponent } from './pages/financial_statements/financial-position/financial-position.component';
import { OperatingResultsComponent } from './pages/financial_statements/operating-results/operating-results.component';
import { AuditorReportComponent } from './pages/auditor_report/auditor-report/auditor-report.component';
import { InitialInterestComponent } from './pages/landing/initial-interest/initial-interest.component';
import { PerformanceSummaryComponent } from './pages/performance_summary/performance-summary/performance-summary.component';
import { LawComponent } from './pages/landing/law/law.component';
import { ManualComponent } from './pages/landing/manual/manual.component';
import { FormComponent } from './pages/landing/form/form.component';
import { InternalDataComponent } from './pages/landing/internal-data/internal-data.component';
import { HistoricalDataComponent } from './pages/historical_data/historical-data/historical-data.component';
import { EstimatedRevenueComponent } from './pages/receivables/estimated-revenue/estimated-revenue.component';
import { RevenuePayAccountComponent } from './pages/receivables/revenue-pay-account/revenue-pay-account.component';
import { ReceivableSummaryComponent } from './pages/receivables/receivable-summary/receivable-summary.component';
import { ReceivableControlComponent } from './pages/receivables/receivable-control/receivable-control.component';
import { AccurateInterestComponent } from './pages/accurate_interest/accurate-interest/accurate-interest.component';
import { AuditByInternalComponent } from './pages/audit_by_Internal/audit-by-internal/audit-by-internal.component';
import { NotFinancialComponent } from './pages/not_financial/not-financial/not-financial.component';
import { LandingComponent } from './pages/landing/landing/landing.component';
import { FinancialstatusReportComponent } from './pages/financialstatus_report/financialstatus-report/financialstatus-report.component';
import { CalConditionsComponent } from './pages/cal_conditions/cal-conditions/cal-conditions.component';
import { PlanResultComponent } from './pages/plan/plan-result/plan-result.component';
import { CompareComponent } from './pages/plan/compare/compare.component';
import { TrialBalanceComponent } from './pages/financial_statements/trial-balance/trial-balance.component';
import { ReceivableDetailComponent } from './pages/receivables/receivable-detail/receivable-detail.component';
import { HeaderLandingComponent } from './pages/ui/header-landing/header-landing.component';
import { ContactComponent } from './pages/landing/contact/contact.component';
import { DataProjectComponent } from './pages/landing/data-project/data-project.component';
import { DashboardsComponent } from './pages/manager/dashboards/dashboards.component';
import { ProjectSupportComponent } from './pages/manager/project-support/project-support.component';
import { FinancialStatementsComponent } from './pages/manager/financial-statements/financial-statements.component';
import { PerformanceAppraisalComponent } from './pages/manager/performance-appraisal/performance-appraisal.component';
import { MeetingMinutesComponent } from './pages/manager/meeting-minutes/meeting-minutes.component';
import { ProjectViewerComponent } from './pages/manager/project-viewer/project-viewer.component';
import { TakeOffComponent } from './pages/manager/take-off/take-off.component';
import { HistoricalCashflowComponent } from './pages/historical-cashflow/historical-cashflow.component';
import { SidebarDashboardComponent } from './pages/sidebar-dashboard/sidebar-dashboard.component';
import { ResultComponent } from './pages/result/result.component';
import { SettingsComponent } from './pages/settings/settings.component';

// export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;
const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [
    AppComponent,
    SidemenuComponent,
    HeaderComponent,
    FooterComponent,
    DashboardComponent,
    FinancialPositionComponent,
    OperatingResultsComponent,
    AuditorReportComponent,
    InitialInterestComponent,
    PerformanceSummaryComponent,
    LawComponent,
    ManualComponent,
    FormComponent,
    InternalDataComponent,
    HistoricalDataComponent,
    EstimatedRevenueComponent,
    RevenuePayAccountComponent,
    ReceivableSummaryComponent,
    ReceivableControlComponent,
    AccurateInterestComponent,
    AuditByInternalComponent,
    NotFinancialComponent,
    LandingComponent,
    FinancialstatusReportComponent,
    CalConditionsComponent,
    PlanResultComponent,
    CompareComponent,
    TrialBalanceComponent,
    ReceivableDetailComponent,
    HeaderLandingComponent,
    ContactComponent,
    DataProjectComponent,
    DashboardsComponent,
    ProjectSupportComponent,
    FinancialStatementsComponent,
    PerformanceAppraisalComponent,
    MeetingMinutesComponent,
    ProjectViewerComponent,
    TakeOffComponent,
    HistoricalCashflowComponent,
    SidebarDashboardComponent,
    ResultComponent,
    SettingsComponent
    ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ChartModule,
    FormsModule,
    ReactiveFormsModule,
    NgxEchartsModule.forRoot({
      echarts,
    }),
    HttpClientModule,
    PdfViewerModule,
    NgxPaginationModule,
    NgxPrintModule,
    NgxMaskModule.forRoot(),
    NgxGalleryModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
